function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M15.4541,9 C13.1711,9 9.9611,5.768 9.3411,5.119 C8.0191,3.741 5.6581,1.8 4.5461,1.8 C3.0421,1.8 1.8181,3.011 1.8181,4.5 C1.8181,5.989 3.0421,7.2 4.5461,7.2 C4.7431,7.2 5.2951,7.116 6.3721,6.401 C6.5781,6.265 6.8541,6.307 7.0001,6.505 L7.5341,7.232 C7.6831,7.437 7.6331,7.732 7.4211,7.873 C6.2891,8.631 5.3451,9 4.5461,9 C2.0391,9 0.0001,6.981 0.0001,4.5 C0.0001,2.019 2.0391,0 4.5461,0 C6.8291,0 10.0391,3.232 10.6591,3.881 C11.9801,5.259 14.3421,7.2 15.4541,7.2 C16.9581,7.2 18.1821,5.989 18.1821,4.5 C18.1821,3.011 16.9581,1.8 15.4541,1.8 C15.2571,1.8 14.7051,1.884 13.6281,2.599 C13.4221,2.735 13.1451,2.693 13.0001,2.495 L12.4661,1.768 C12.3161,1.563 12.3671,1.268 12.5791,1.127 C13.7111,0.369 14.6551,0 15.4541,0 C17.9611,0 20.0001,2.019 20.0001,4.5 C20.0001,6.981 17.9611,9 15.4541,9",
  id: "path-1"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 -5 20 20"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/suggestions.57ac0c75.svg";
export { SvgComponent as ReactComponent };